<template>

    <div class="text-center tracking-wider mt-16 md:mt-32 py-16 bg-gray-50">

        <div class="max-w-5xl mx-auto px-4">
            <h1 class="text-5xl font-semibold">
                It's your car, it's your privacy
            </h1>
            <p class="mt-3 font-lg">
                The Carbuck's Health Monitor quietly oversees your vehicle's health,
                dashboard warnings and alerts, any errors reported by your car's computer, 
                and all it's scheduled and ad-hoc maintenance tasks.
            </p>
            <p class="mt-3 font-lg">
                Unlike other vehicle monitors, and the computer systems built into some cars, 
                <br class="hidden md:block"/>
                <span class="text-primary-600 font-bold uppercase">
                    Carbucks does not track your location or report your data to third parties!
                </span>
            </p>
            <p class="mt-3 mb-8 font-lg">
                Designed to safeguard your car and your investment in it, Carbucks provides peace of mind to
                you and your family whilst helping to reduce your running costs and expenses.
            </p>            
            <Button color="var(--color-primary-600)"
                    variant="flat"
                    to="/carbucks-privacy-policy"
                    class="!h-12 !rounded-[8px] text-white">
                <span class="mr-2 ">Full Privacy Policy</span>
                <Icon name="arrow-right" />
            </Button>
        </div>

    </div>

</template>